import { render, staticRenderFns } from "./PartografPrint.vue?vue&type=template&id=12ddbdd7&"
import script from "./PartografPrint.vue?vue&type=script&lang=ts&"
export * from "./PartografPrint.vue?vue&type=script&lang=ts&"
import style0 from "./PartografPrint.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports